var testNameRegex = /(.+)(\()(\d+.*)\)/;
var splitTestNameAndGenesCount = function (testName) {
    var match = testNameRegex.exec(testName);
    return (match && {
        genesCount: match[3].toLowerCase(),
        name: match[1],
    });
};

export { splitTestNameAndGenesCount };
//# sourceMappingURL=extractGenesCount.esm.js.map
